import React from 'react';
import { BtnPrimary } from '../../../Components/share/buttons/Btn';
import dist1 from '../../../Assets/Image/png/dist-1.png';
import dist2 from '../../../Assets/Image/png/dist-2.png';
import dist3 from '../../../Assets/Image/png/dist-3.png';
import dist4 from '../../../Assets/Image/png/dist-4.png';
import HomeCard from './HomeCard';
import { HashLink } from 'react-router-hash-link';

const Distionction = () => {
	const cards = [
		{
			pic: dist1,
			title: 'ارتباط آنلاین',
			content: 'به راحتی و از هر مکان و زمانی با دیگران ارتباط بگیرید.',
		},
		{
			pic: dist2,
			title: 'پروژه‌ی عملی',
			content: 'پروژه‌های عملی و در دنیای واقعی را پیش ببرید.',
		},
		{
			pic: dist3,
			title: 'تیم‌سازی',
			content:
				'با دیگر افراد علاقمند به این حوزه آشنا شوید و شبکه‌سازی کنید.',
		},
		{
			pic: dist4,
			title: 'پشتیبانی',
			content: 'با پشتیبانی کامل و 24/7 بوت‌وب جایی برای نگرانی نیست.',
		},
	];

	return (
		<div className='home__distinction flex flex-col justify-center items-center container pb-[5rem]'>
			<div className='text-[3.4rem] font-bold pb-12 text-primary-dark'>
				<p>چرا بوت‌وب متمایز است؟</p>
			</div>
			<div className='flex w-full justify-center items-stretch gap-10 home__distinction--list-card'>
				{cards.map(({ pic, title, content }) => {
					return (
						<HomeCard
							key={title}
							image={pic}
							title={title}
							content={content}
						/>
					);
				})}
			</div>
			<div>
				<HashLink key='options' to='/options#top'>
					<BtnPrimary
						text='مشاهده‌ی کامل امکانات'
						className='leading-10 px-6 py-3'
						type='button'
					/>
				</HashLink>
			</div>
		</div>
	);
};

export default Distionction;
